import React, { Fragment } from "react";
import { connect } from "react-redux";
import { authCheckState } from "../../../store/actions/auth";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import GeneralSetting from "../Setting/index";
import { getSetting, postSetting } from "../../../store/actions/setting";
import { Menu } from "antd";
import "antd/dist/antd.css";
import TrainingType from "../traningtype/index";
import Trainier from "../trainer/index";
import EmailTemplate from "../EmailTemplate";
import CostManagement from "../costManagement";
import { Switch, Route, Link } from "react-router-dom";

import { Row, Col } from "antd";
const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100ch",
    },
    input: {
      display: "none",
    },
  },
});

class Setting extends React.Component {
  state = {
    print_on_submit: true,
    name: "",
    address: "",
    phone_number: "",
    print_size: "3.5",
    data: {},
    errorMessage: "",
    sigimage: null,
    sigimageUrl: "",
    logimage: null,
    logimageUrl: "",
    headmaster_name: "",
    video_link: "https://www.youtube.com/watch?v=eKqWrEL-wgk",
    default_email: "",
    sent_mail_to_participant: true,
    key: "1",
  };

  componentDidMount() {
    this.props.getSetting(this.props.token);
    this.props.authCheckState();

    this.setState({
      name: this.props.setting.name,
      address: this.props.setting.address,
      headmaster_name: this.props.setting.headmaster_name,
      phone_number: this.props.setting.phone_number,
      sigimage: this.props.setting.principal_signature,
      sigimageUrl: this.props.setting.principal_signature,
      logimage: this.props.setting.logo,
      logimageUrl: this.props.setting.logo,
      mail_email: this.props.setting.mail_email,
      mail_subject: this.props.setting.mail_subject,
      mail_text: this.props.setting.mail_text,
      mail_password: this.props.setting.mail_password,
      video_link: this.props.setting.video_link,
      default_mail: this.props.setting.default_mail,
      sent_mail_to_participant: this.props.setting.sent_mail_to_participant,
    });
  }

  handleClick = (e) => {
    this.setState({ key: e.key });
  };
  // renderSwitch(param) {
  //   switch (param) {
  //     case "1":
  //       return <Redirect to={"/generalsetting"} />;
  //     case "2":
  //       return <TrainingType />;
  //     case "3":
  //       return <Trainier />;
  //     case "4":
  //       return <CostManagement />;
  //     case "5":
  //       return <EmailTemplate />;
  //     case "6":
  //       return <TrainingType />;
  //     default:
  //       return <div>Sorry Nothing Selected</div>;
  //   }
  // }

  render() {
    const { permissions } = this.props;
    return (
      <Fragment>
        <Row>
          <Col span={4}>
            <Menu
              onClick={this.handleClick}
              style={{ width: 200, height: "100%", backgroundColor: "white" }}
              defaultSelectedKeys={[""]}
              defaultOpenKeys={["sub1"]}
              mode="inline"
            >
              {!permissions ||
              (permissions &&
                permissions.length &&
                permissions.indexOf("setting-list") >= 0) ? (
                <Menu.Item key="1">
                  <Link to={"/admin/setting/generalSetting"}>सेटिंग्स</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {!permissions ||
              (permissions &&
                permissions.length &&
                permissions.indexOf("training-type-list") >= 0) ? (
                <Menu.Item key="2">
                  <Link to={"/admin/setting/training"}>प्रशिक्षण</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {!permissions ||
              (permissions &&
                permissions.length &&
                permissions.indexOf("trainer-list") >= 0) ? (
                <Menu.Item key="3">
                  <Link to={"/admin/setting/trainer"}>प्रशिक्षक</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {!permissions ||
              (permissions &&
                permissions.length &&
                permissions.indexOf("cost-management-list") >= 0) ? (
                <Menu.Item key="4">
                  <Link to={"/admin/setting/const-mamangement"}>
                    लागत व्यवस्थापन
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {!permissions ||
              (permissions &&
                permissions.length &&
                permissions.indexOf("email-template-list") >= 0) ? (
                <Menu.Item key="5">
                  <Link to={"/admin/setting/email-template"}>
                    ईमेल टेम्पलेट
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )}
            </Menu>
          </Col>
          <Col span={19}>
            <Switch>
              <Route path="/admin/setting/generalsetting">
                <GeneralSetting />
              </Route>
              <Route path="/admin/setting/training">
                <TrainingType />
              </Route>
              <Route path="/admin/setting/trainer">
                <Trainier />
              </Route>
              <Route path="/admin/setting/const-mamangement">
                <CostManagement />
              </Route>

              <Route path="/admin/setting/email-template">
                <EmailTemplate />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.setting.error,
    token: state.auth.token,
    setting: state.setting.setting,
    permissions:
      typeof state.auth.user["permissions"] != "undefined"
        ? state.auth.user.permissions
        : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSetting: (token) => dispatch(getSetting(token)),
    postSetting: (data, token, onSuccess, onError) =>
      dispatch(postSetting(data, token, onSuccess, onError)),
    authCheckState: () => dispatch(authCheckState()),
  };
};

export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(Setting);
